import React from "react";
import Footer from "../component/Footer";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import { MdLocationPin } from "react-icons/md";
import {
  FaFacebook,
  FaInstagram,
  FaLine,
  FaPhoneAlt,
  FaPhoneSquareAlt,
} from "react-icons/fa";
import { HiArrowUpRight } from "react-icons/hi2";

export default function ContactUs1() {
  // const { isLoaded } = useLoadScript({
  //   googleMapsApiKey: "",
  // });
  // if (!isLoaded) return <div> Loading... </div>;

  return (
    <div>
      <div className="bg-slate-100 py-24 sm:py-32 ">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className=" my-5 mx-auto max-w-max rounded-full bg-white px-5 py-1 text-center text-2xl font-extrabold  text-purple-500">
              Contact Us
            </h2>
            <p className=" mx-auto  max-w-3xl text-center text-5xl font-extrabold   leading-tight tracking-tight text-gray-800 sm:max-w-lg sm:text-7xl 2xl:max-w-3xl 2xl:text-9xl">
              <span className="text-purple-500 ">ช่องทางการติดต่อ</span>พวกเรา
            </p>
          </div>
        </div>

        <div className="mx-auto grid max-w-screen-2xl gap-5 px-6 py-10 sm:mt-20 lg:px-8 xl:grid-cols-2  ">
          <div className="rounded-3xl bg-white p-2 sm:p-8">
            <img src="./img/try.jpg" className="rounded-3xl" alt="" />
            <a
              href="https://goo.gl/maps/mm3gFQ1VJvo5qzra8"
              target="_blank"
              rel="noreferrer"
            >
              <p className="mt-5 inline-block rounded-3xl border border-gray-800 bg-gray-800 p-5 text-xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 ">
                View on Google Map &nbsp;
                <HiArrowUpRight className="inline" />
              </p>
            </a>
          </div>
          <div>
            <div className="mb-5 rounded-3xl bg-white p-5 sm:p-10">
              <div className="flex">
                <span>
                  <MdLocationPin className="inline fill-red-500 text-4xl sm:mr-5 sm:text-5xl" />
                </span>
                <div className="flex-col">
                  <h1 className="my-2 text-3xl font-bold text-gray-800 sm:text-4xl">
                    สำนักงาน กาลิเลโอ ติวเตอร์
                  </h1>
                  <h3 className="text-xl text-gray-800 sm:text-2xl">
                    29/157 หมู่บ้านกลางเมือง สาทร - สุขสวัสดิ์ ซอยสุขสวัสดิ์ 39
                    ต.บางพึ่ง อ.พระประแดง 10130
                  </h3>
                </div>
              </div>
            </div>
            <div className="mb-5 rounded-3xl bg-white p-5 sm:p-10">
              <div className="flex">
                <span>
                  <MdLocationPin className="inline fill-red-500 text-4xl sm:mr-5 sm:text-5xl" />
                </span>
                <div className="flex-col">
                  <h1 className="my-2 text-3xl font-bold text-gray-800 sm:text-4xl">
                    Galileo Tutor Office
                  </h1>
                  <h3 className="text-xl text-gray-800 sm:text-2xl">
                    29/157 Baan Klang Muang Sathorn - Suksawat, soi suksawat 39,
                    Bang Phueng, Phra Pradaeng, Samut Prakan 10130
                  </h3>
                </div>
              </div>
            </div>
            <div className=" mb-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-2">
              <div className="rounded-3xl bg-white p-7 md:p-10 xl:p-7 2xl:p-10">
                <h1 className="my-2 text-4xl font-bold text-gray-800">
                  Social Media
                </h1>
                <h3 className="my-4  ">
                  <FaFacebook className="inline text-4xl text-blue-600 md:mr-5 xl:mr-0 2xl:mr-5" />
                  <a
                    target="_blank"
                    className="text-2xl text-blue-500 "
                    href="https://www.facebook.com/GalileoTutor"
                    rel="noreferrer"
                  >
                    &nbsp; GalileoTutor
                  </a>
                </h3>
                <h3 className="my-4  ">
                  <FaInstagram className="inline text-4xl text-pink-500 md:mr-5 xl:mr-0 2xl:mr-5" />
                  <a
                    target="_blank"
                    className="text-2xl text-blue-500 "
                    href="https://www.instagram.com/galileo_tutor/"
                    rel="noreferrer"
                  >
                    &nbsp; galileo_tutor
                  </a>
                </h3>
                <h3 className="my-4  ">
                  <FaLine className="inline text-4xl text-green-500 md:mr-5 xl:mr-0 2xl:mr-5" />
                  <a
                    target="_blank"
                    className="text-2xl text-blue-500 "
                    href="https://line.me/R/ti/p/@efj7400q"
                    rel="noreferrer"
                  >
                    &nbsp; @galileo_tutor
                  </a>
                </h3>
              </div>
              <div className="rounded-3xl bg-white p-7 md:p-10">
                <h1 className="my-2 text-4xl font-bold text-gray-800">
                  ติดต่อ
                </h1>
                <h3 className="my-4  ">
                  <FaPhoneSquareAlt className="inline text-4xl text-green-500 md:mr-5 xl:mr-0 2xl:mr-5" />
                  <a
                    target="_blank"
                    className="text-2xl text-blue-500 "
                    href="tel:0817842186"
                    rel="noreferrer"
                  >
                    &nbsp; 081-7842186
                  </a>
                </h3>
                <h3 className="my-4  ">
                  <FaPhoneSquareAlt className="inline text-4xl text-green-500 md:mr-5 xl:mr-0 2xl:mr-5" />
                  <a
                    target="_blank"
                    className="text-2xl text-blue-500 "
                    href="tel:084-7720046"
                    rel="noreferrer"
                  >
                    &nbsp; 084-7720046
                  </a>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
